import { PATHS } from "router/config/paths";
import { MenuTechPack } from "icons/menuIcons";
import type { MenuItem, MenuSection } from "./useMenuItems";

/** The Tech Pack entry, with "Tech Packs" and "Fit Models" as its children. Pure: every other entry is untouched. */
export const withFitModelsUnderTechPack = (sections: MenuSection[], labels: { techPacks: string; fitModels: string }): MenuSection[] =>
  sections.map((section) => ({
    ...section,
    items: section.items.map(
      (item): MenuItem =>
        item.key !== "tech-pack"
          ? item
          : {
              ...item,
              exact: true,
              children: [
                { key: "tech-pack-projects", name: labels.techPacks, path: PATHS.TECH_PACKS, icon: MenuTechPack, analyticsEvent: "nav_techpack_click" },
                { key: "fit-models", name: labels.fitModels, path: PATHS.FIT_MODELS.replace("/:id?", ""), icon: MenuTechPack, analyticsEvent: "nav_fitmodels_click" },
              ],
            }
    ),
  }));
